import React, { Component } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import './PanelContent.scss';

class PanelContent extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    forwardedRef: PropTypes.node
  };

  render() {
    const { children, className, forwardedRef } = this.props;

    const classComponent = classNames('panel__content', className);

    return (
      <div className={classComponent} ref={forwardedRef}>
        {children}
      </div>
    );
  }
}

const WrappedComponent = React.forwardRef((props, ref) => (
  <PanelContent {...props} forwardedRef={ref} />
));

export default WrappedComponent;
